import styled from 'styled-components'

export const Skills = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    height: auto;

    margin: 40px 0 40px 0;
    max-width: 1234px;

`

export const SkillInfo = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    align-content: center; 

    color: white;
`